var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagSolomonIslands(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_16488)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.3141 27.3249C33.3148 21.3242 33.5518 11.7439 28.0274 5.45898L16 16.0107L5.44824 28.0382C11.7332 33.5625 21.3134 33.3256 27.3141 27.3249Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.68587 4.69661C10.6865 -1.30407 20.2668 -1.541 26.5518 3.9833L16 16.0109L3.97262 26.5625C-1.55175 20.2776 -1.31475 10.6973 4.68587 4.69661Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5516 3.98315L3.9725 26.5624C4.20075 26.822 4.43775 27.0768 4.68581 27.3247C4.93381 27.5727 5.18863 27.8097 5.44838 28.0381L28.0274 5.4589C27.7991 5.19915 27.5621 4.9444 27.314 4.69634C27.0661 4.44847 26.8113 4.2114 26.5516 3.98315Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.74129 5.57544L7.08672 6.63837H8.20428L7.30016 7.29519L7.64547 8.35812L6.74129 7.70118L5.8371 8.35812L6.18254 7.29519L5.27835 6.63837H6.39597L6.74129 5.57544Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4503 5.57544L12.7957 6.63837H13.9132L13.0091 7.29519L13.3545 8.35812L12.4503 7.70118L11.5461 8.35812L11.8915 7.29519L10.9873 6.63837H12.1049L12.4503 5.57544Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.74129 11.1409L7.08672 12.2038H8.20428L7.30016 12.8607L7.64547 13.9236L6.74129 13.2667L5.8371 13.9236L6.18254 12.8607L5.27835 12.2038H6.39597L6.74129 11.1409Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4503 11.1409L12.7957 12.2038H13.9132L13.0091 12.8607L13.3545 13.9236L12.4503 13.2667L11.5461 13.9236L11.8915 12.8607L10.9873 12.2038H12.1049L12.4503 11.1409Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.59566 8.35815L9.94109 9.42109H11.0586L10.1545 10.078L10.4998 11.1409L9.59566 10.484L8.69147 11.1409L9.03685 10.078L8.13266 9.42109H9.25028L9.59566 8.35815Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_16488"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.0107422)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagSolomonIslands);
export default __webpack_public_path__ + "static/media/flag_solomon_islands.39eae6ead6bec6a0ab5bc74c43d483fb.svg";
export { ForwardRef as ReactComponent };